<h1>Forgot Password</h1>
<div id="info">Enter your email and we will send you a link to change your password</div>
<form (submit)="submit($event)">
  <div>
    <mat-form-field>
      <input matInput
             placeholder="Email"
             [formField]="forgotPasswordForm.email">
      <mat-error>
          <app-field-errors [formField]="forgotPasswordForm.email"></app-field-errors>
      </mat-error>
    </mat-form-field>
  </div>
  <div id="button_row">
    <button mat-raised-button
            class="button"
            type="submit"
            color="primary"
            [disabled]="forgotPasswordForm().invalid() || isBusy()">Send Link</button>
    <button mat-raised-button
            class="button"
            type="button"
            [disabled]="isBusy()"
            routerLink="/login">Cancel</button>
  </div>
</form>
